import { Component } from '@angular/core';
import { WhatsAppMessage } from 'src/app/utils/constants';
import { buildWhatsAppUrl } from 'src/app/utils/utils';
import { environment } from 'src/environments/environment';

const { baseUrl, phoneNumber, clientId } = environment.vambe;
@Component({
	selector: 'app-whatsapp-contact',
	templateUrl: './whatsapp-contact.component.html',
	styleUrls: ['./whatsapp-contact.component.scss'],
})
export class WhatsAppContactComponent {
	readonly whatsAppContactUrl = buildWhatsAppUrl(baseUrl, phoneNumber, clientId, WhatsAppMessage);
}
